import React, { useEffect, useState } from "react";
import Layout from "../../Layout";
import membercard from "../../assets/images/Svg/membercardbg.svg";
import Teleconsult from "../../assets/membership/Teleconsult.svg";
import Labtest from "../../assets/membership/Labtest.svg";
import Medicine from "../../assets/membership/Medicineorder.svg";
import { FaCheck, FaCheckCircle } from "react-icons/fa";
import { CgClose } from "react-icons/cg";
import { GoArrowLeft } from "react-icons/go";
import { FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  handleLoginSignUpModal,
  LOGINMODAL,
} from "../../Redux/actions/commonActions";
import { Drawer, Flex, Modal, Select, Spin, Tooltip } from "antd";
import { fetchMembershipPlans } from "../../Redux/actions/membershipActions";
import PurchaseMembership from "./PurchaseMembership";

const JoinMembership = ({ onSubmit }) => {
  const { patientData } = useSelector((state) => state.auth);
  const [sidePanel, setSidePanel] = useState(false);
  const [planType, setPlanType] = useState("");
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [discount, setDiscount] = useState({});
  const [moreModal, setMoreModal] = useState(false);
  const [selectedItemDetails, setSelectedItemDetails] = useState(null);
  const { memberShipPlans, isLoading } = useSelector(
    (state) => state.memberships
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchMembershipPlans({ status: 1 }));
  }, []);

  useEffect(() => {
    if (memberShipPlans) {
      const newDiscounts = {};
      for (let plan of memberShipPlans) {
        let max = -1;
        for (let feature of plan?.membershipServiceDetailsList) {
          if (feature?.serviceCategory !== "APPT") {
            max = Math.max(feature?.discountPercentage, max);
          }
        }
        newDiscounts[plan?.code?.toLowerCase()] = max;
      }
      setDiscount(newDiscounts);
    }
  }, [memberShipPlans]);

  const handleSidePanel = (type, plan) => {
    if (patientData && patientData.patientId) {
      setSidePanel(true);
      setPlanType(type);
      setSelectedPlan(plan);
    } else {
      dispatch(handleLoginSignUpModal({ data: true, actionType: LOGINMODAL }));
    }
  };

  const handleCloseSidePanel = () => {
    setSidePanel(false);
    setPlanType("");
  };

  const handleCloseMoreModal = () => {
    setMoreModal(false);
    setSelectedItemDetails(null);
  };

  const handleOpenMoreModal = (plan) => {
    setMoreModal(true);
    setSelectedItemDetails(plan);
  };

  const getPlanStyles = (code) => {
    switch (code?.toUpperCase()) {
      case "SINGLE":
        return {
          borderColor: "border-[#81CAF4]",
          gradient: "from-[#C3E9FF] to-[#66BEF1]",
          textColor: "text-[#11B0BD]",
          checkColor: "text-[#6EC2F2]",
          cardClass: "border",
        };
      case "TWIN":
        return {
          borderColor: "border-[#5DEB6D]",
          gradient: "from-[#CDFFBF] to-[#8AC67A]",
          textColor: "text-[#34CF47]",
          checkColor: "text-[#6EC2F2]",
          cardClass: "border",
        };
      case "FAMILY":
        return {
          borderColor: "border-[#1DBBB6]",
          gradient: "from-[#C5FFF9] to-[#60DFD2]",
          textColor: "text-[#1EBBB6]",
          checkColor: "text-[#6EC2F2]",
          isBestValue: true,
          badgeGradient: "from-[#96EAE3] to-[#16736B]",
          cardClass: "border-[#1DBBB6] border-2 shadow-inner shadow-[#1DBBB6]",
        };
      default:
        return {
          borderColor: "border-[#81CAF4]",
          gradient: "from-[#C3E9FF] to-[#66BEF1]",
          textColor: "text-[#11B0BD]",
          checkColor: "text-[#6EC2F2]",
          cardClass: "border",
        };
    }
  };

  if (isLoading) {
    return (
      <Layout>
        <div className="h-screen flex items-center justify-center">
          <Flex align="center" gap="middle">
            <Spin size="large" tip="Loading" />
          </Flex>
        </div>{" "}
      </Layout>
    );
  }

  return (
    <Layout>
      <div
        className="bg-cover bg-center w-full h-64 border border-[#A3D4D8] relative scrollHidth"
        style={{ backgroundImage: `url(${membercard})` }}
      >
        <div className="flex justify-center mt-12">
          <button className="bg-white text-sm font-inter font-medium text-[#232323] border border-[#0DA6B3] px-5 py-1 rounded-full shadow">
            Join membership
          </button>
        </div>
        <h2 className="text-[#232323] text-center text-base font-sans font-bold mt-5">
          Get more from your healthcare—join today and <br /> unlock{" "}
          <span className="text-[#0573DB]">
            exclusive discounts and benefits
          </span>{" "}
          on,
        </h2>
        <div className="flex sm:flex-col justify-center gap-6 mt-7">
          <div>
            <div className="bg-white border rounded-lg w-40 h-28 flex items-center justify-center">
              <img src={Teleconsult} alt="" />
            </div>
            <p className="text-[#232323] font-sans font-semibold text-center mt-2 text-sm">
              Tele-consultation
            </p>
          </div>
          <div>
            <div className="bg-white border rounded-lg w-40 h-28 flex items-center justify-center">
              <img src={Labtest} alt="" />
            </div>
            <p className="text-[#232323] font-sans font-semibold text-center mt-2 text-sm">
              Lab Test
            </p>
          </div>
          <div>
            <div className="bg-white border rounded-lg w-40 h-28 flex items-center justify-center">
              <img src={Medicine} alt="" />
            </div>
            <p className="text-[#232323] font-sans font-semibold text-center mt-2 text-sm">
              Medicine order
            </p>
          </div>
        </div>
        <div className="flex gap-2 items-center absolute -bottom-14 px-7">
          <p className="text-sm font-sans font-semibold text-[#189FAA]">
            Patient Membership
          </p>
          /
          <p className="text-sm font-sans font-semibold text-[#232323]">
            Membership Purchase
          </p>
        </div>

        <div className="max-w-7xl mx-auto px-4 mt-10 flex sm:flex-col  justify-center gap-4 pb-10">
          {patientData && !patientData?.membershipCard && (
            <div className="w-full md:w-1/2 lg:w-1/4 xl:w-1/4 bg-white rounded-xl shadow-md p-6 border">
              <h3 className="text-base font-semibold rounded-md border-2 mt-1 shadow-md p-1 text-center font-sans w-20">
                Free
              </h3>
              <p className="text-xl font-bold mt-4">
                ₹0{" "}
                <span className="text-sm font-normal text-gray-500">/ mo</span>
              </p>
              <button className="bg-[#D9D9D9] font-sans text-base mt-12 w-full py-2 rounded-md font-semibold">
                Current Plan
              </button>
              <p className="border rounded-md p-2 font-sans text-xs font-medium shadow-md mt-5 text-gray-600">
                <span className="text-black font-semibold">No discounts</span>{" "}
                on all consultation, medicines, lab tests & other services
              </p>
              <ul className="text-sm font-sans font-semibold text-gray-600 mt-5 space-y-2 ">
                <li className="flex gap-2">
                  <FaCheck className="text-gray-400 mt-1" />
                  <span>Up to 10 consultations per month</span>
                </li>
                <li className="flex gap-2">
                  <FaCheck className="text-gray-400 mt-1" />
                  <span>5 free follow-up consultations</span>
                </li>
                <li className="flex gap-2">
                  <FaCheck className="text-gray-400 mt-1" />
                  <span>Free home delivery for medicines (one per month)</span>
                </li>
                <li className="flex gap-2">
                  <FaCheck className="text-gray-400 mt-1" />
                  <span>Medicine reminders via app or SMS</span>
                </li>
                <li className="flex gap-2">
                  <FaCheck className="text-gray-400 mt-1" />
                  <span>1 free basic health checkup annually</span>
                </li>
                <li className="flex gap-2">
                  <FaCheck className="text-gray-400 mt-1" />
                  <span>Online lab report storage and access</span>
                </li>
              </ul>
            </div>
          )}
          {memberShipPlans?.map((plan) => {
            const styles = getPlanStyles(plan.code);
            const planDiscount = discount[plan.code.toLowerCase()];
            return (
              <div
                key={plan.id}
                className={`w-full md:w-1/2 lg:w-1/4 xl:w-1/4 bg-white rounded-xl shadow-md p-6 relative ${styles.cardClass}`}
              >
                {styles.isBestValue && (
                  <div
                    className={`absolute top-0 right-0 bg-gradient-to-r ${styles.badgeGradient} text-white font-sans text-xs font-semibold px-3 py-1 rounded-tr-lg rounded-bl-lg`}
                  >
                    Best Value
                  </div>
                )}
                <div
                  className={`border-2 rounded-md ${styles.borderColor} w-36 text-center p-1 shadow-md`}
                >
                  <h3 className="text-base font-sans font-semibold">
                    {plan.description.split(" ")[0]} member
                  </h3>
                  <p className="text-xs font-sans text-gray-500">Membership</p>
                </div>
                <p className="text-sm font-sans font-medium text-[#595959] mt-2">
                  {plan.totalMembersAllowed === 0
                    ? "Single family member only allowed"
                    : plan.totalMembersAllowed === 1
                    ? "Two family members only allowed"
                    : `${plan.totalMembersAllowed + 1} family members only allowed`}
                </p>
                <p className="text-xl font-bold mt-2">
                  ₹{plan?.actualAmount}
                  <span className="text-sm font-normal text-gray-500">
                    / mo
                  </span>
                </p>
                <button
                  className={`bg-gradient-to-r ${styles.gradient} text-[#232323] font-sans mt-4 w-full py-2 rounded-md font-semibold`}
                  onClick={() =>
                    handleSidePanel(plan.code.toLowerCase(), plan)
                  }
                >
                  Purchase now
                </button>
                <p className="border rounded-md p-2 font-sans text-xs font-medium shadow-md mt-5 text-gray-600">
                  <span className={`font-semibold ${styles.textColor}`}>
                    {plan.code === "HEALTHCHECK" ? "" : `${planDiscount}% `}
                  </span>
                  {plan.upto_Discount_Percent}
                  <span
                    className="text-[#3285D9] underline cursor-pointer ml-1"
                    onClick={() => handleOpenMoreModal(plan)}
                  >
                    Learn more
                  </span>
                </p>
                <ul className="text-sm font-sans font-semibold text-gray-600 mt-5 space-y-2 ">
                  {plan?.membershipServiceDetailsList?.map((service, idx) => (
                    <li className="flex gap-2" key={idx}>
                      <FaCheck className={`${styles.checkColor} mt-1`} />
                      <span>
                        {service?.serviceName} ({service?.serviceCategory})
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <Drawer
          title="Add Patient details"
          open={sidePanel}
          destroyOnClose
          onClose={handleCloseSidePanel}
          width={"30%"}
          className="membershipDrawer"
        >
          <PurchaseMembership
            handleSidePanel={handleCloseSidePanel}
            planType={planType}
            selectedPlan={selectedPlan}
          />
        </Drawer>

        <Modal
          open={moreModal}
          onCancel={handleCloseMoreModal}
          destroyOnClose
          footer={[]}
          title={selectedItemDetails?.description}
        >
          <div>
            <div className="mt-4 pt-3 border-t bg-gray-50 text-gray-400 p-2 -mx-4 -mb-4 rounded-b-xl text-sm">
              <span className="text-[#6FC2F2] font-semibold">
                {selectedItemDetails?.upto_Discount_Percent}
              </span>{" "}
            </div>
            <ul className="mt-4">
              {selectedItemDetails?.membershipServiceDetailsList?.map(
                (service, idx) => (
                  <li className="flex items-center py-0.5" key={idx}>
                    <svg
                      className="w-4 h-4 mr-2 text-[#34CF47] flex-shrink-0"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span className="font-semibold mx-1">
                      {service?.discountPercentage}% Discount
                    </span>
                    <span className="text-gray-400">{service?.serviceName}</span>
                  </li>
                )
              )}
            </ul>
          </div>
        </Modal>
      </div>
    </Layout>
  );
};

export default JoinMembership;
